import React, { useMemo } from 'react';

import EntityDropDownFilterContainerComponent from 'components/entityViewer/entitiesDropDownFilter/EntityDropDownFilterContainer';
import {
    CrossDockPurchaseOrderFilterConfigArray,
    FILTER_QUERY_KEYS,
} from 'components/logistics/components/crossDockPurchaseOrders/CrossDockPurchaseOrderFilterConfig';
import {
    useCrossDockOptions,
    useFacilityOptions,
} from 'components/procurement/components/purchaseOrdersV2/queries/PurchaseOrderQueries';

/**
 * @param {Object} props
 * @param {Object} [props.initialValues={}]
 * @param {(nextFilters: Object) => void} [props.onChange]
 */
export function CrossDockPurchaseOrderFilters({ initialValues = {}, onChange }) {
    const { data: facilityOptions = [], isLoading: isLoadingFacilities } = useFacilityOptions();
    const { data: crossDockOptions = [], isLoading: isLoadingCrossDocks } = useCrossDockOptions();

    const effectiveFilterConfigs = useMemo(
        () =>
            CrossDockPurchaseOrderFilterConfigArray.map((cfg) => {
                const queryId = cfg.remoteOptions?.queryId;

                if (queryId === FILTER_QUERY_KEYS.FACILITIES) {
                    return {
                        ...cfg,
                        options: facilityOptions,
                        menuProps: {
                            ...cfg.menuProps,
                            isLoading: isLoadingFacilities,
                        },
                    };
                }

                if (queryId === FILTER_QUERY_KEYS.CROSS_DOCKS) {
                    return {
                        ...cfg,
                        options: crossDockOptions,
                        menuProps: {
                            ...cfg.menuProps,
                            isLoading: isLoadingCrossDocks,
                        },
                    };
                }

                return cfg;
            }),
        [crossDockOptions, facilityOptions, isLoadingCrossDocks, isLoadingFacilities],
    );

    const handleFilterChange = (filterValues) => {
        if (onChange) {
            onChange(filterValues);
        }
    };

    return (
        <EntityDropDownFilterContainerComponent
            title="Cross Dock Purchase Order Filters"
            filterConfigs={effectiveFilterConfigs}
            initialValues={initialValues}
            onChange={handleFilterChange}
            autoApply
        />
    );
}
